export const formatNumberPrecise = (num, maxDecimals = 3) => {
  if (typeof num === 'string') num = parseFloat(num);
  if (typeof num !== 'number' || isNaN(num)) return '0';

  const absNum = Math.abs(num);
  const sign = num < 0 ? '-' : '';

  const thresholds = [
    { value: 1_000_000, suffix: 'M' },
    { value: 1_000, suffix: 'k' },
  ];

  for (const { value, suffix } of thresholds) {
    if (absNum >= value) {
      const scaledNum = absNum / value;
      const formatted = scaledNum.toFixed(maxDecimals).replace(/\.?0+$/, '');
      return `${sign}${formatted}${suffix}`;
    }
  }

  return `${sign}${absNum}`;
};